import classnames from 'classnames/bind'
import Company from 'entities/company'
import PropTypes from 'prop-types'
import React from 'react'
import { propTypeInstantiableTo } from 'supports/custom_prop_types'
import Link from './link'
import styles from './offer_page_header.module.scss'

const cx = classnames.bind(styles)

const OfferPageHeader = ({ articleAvailable, articlesUrl, offersUrl, company }) => (
  <header className={styles.header}>
    <div className={styles.headerRow}>
      <a href={offersUrl}>
        <div className={styles.companyNames}>
          {company.logo.url === null ? null : (
            <div className={styles.companyLogo}>
              <img className={styles.companyLogoImage} src={company.logo.thumb.url} alt={company.name} />
            </div>
          )}
          <div className={cx(styles.companyName, { companyNameHasLogo: company.logo.url !== null })}>
            {company.name}
          </div>
        </div>
      </a>
      {articleAvailable && articlesUrl !== null ? (
        <Link
          className={styles.articlesLink}
          href={articlesUrl}
          value={I18n.t('components.offer_page_header.articles_link')}
        />
      ) : null}
    </div>
  </header>
)

OfferPageHeader.propTypes = {
  articleAvailable: PropTypes.bool.isRequired,
  articlesUrl: PropTypes.string,
  offersUrl: PropTypes.string.isRequired,
  company: propTypeInstantiableTo(Company).isRequired
}

OfferPageHeader.defaultProps = {
  articlesUrl: null
}

export default OfferPageHeader
window.OfferPageHeader = OfferPageHeader
